import { render, staticRenderFns } from "./MixinIdle.vue?vue&type=template&id=6ea87470&lang=html&"
import script from "./MixinIdle.vue?vue&type=script&lang=js&"
export * from "./MixinIdle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports